import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-expand-more",
  "use": "ico-expand-more-usage",
  "viewBox": "0 0 18.623 10.66",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.623 10.66\" id=\"ico-expand-more\">\n  <path id=\"ico-expand-more_Path_1437\" data-name=\"Path 1437\" d=\"M302.13,25.5l8.167,8.524,9.048-8.524\" transform=\"translate(-301.408 -24.772)\" fill=\"none\" stroke=\"#737878\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol